import ProductDescription from './ProductDescription'

const BarleyProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '006',
  IsBroadband: true,
  GrainSize: '',
  BarleyVerification: '',
  Organic: false,
}

export default BarleyProduct
